import { designTokens as p } from "../design-tokens.js";
import { colorRange as n } from "./tokens/color-range.js";
import { normalizeTheme as o } from "./theme-utils.js";
import { defaultDesignSystemConfig as b } from "../config.js";
function D(i, a, r = b.htmlFontSize) {
  c(o(i), a, r);
}
function c(i, a, r) {
  d(p.htmlFontSize, r.toString()), R(p.color, i.color[a]), d(p.fontFamily.sans, i.fontFamily.sans), d(p.fontFamily.mono, i.fontFamily.mono), T(p.fontSize, i.fontSize, r), g(p.lineHeight, i.lineHeight), g(p.fontWeight, i.fontWeight), d(p.fontWeight.regular, i.fontWeight.regular), d(p.fontWeight.semibold, i.fontWeight.semibold), d(p.fontWeight.bold, i.fontWeight.bold), d(p.transition.fast, i.transition.fast), x(p.shadow.box, i.shadow[a].box), x(p.shadow.drop, i.shadow[a].drop), l(
    p.borderWidth.xs,
    i.borderWidth.xs,
    r
  ), l(
    p.borderWidth.sm,
    i.borderWidth.sm,
    r
  ), l(
    p.borderRadius.xs,
    i.borderRadius.xs,
    r
  ), l(
    p.borderRadius.sm,
    i.borderRadius.sm,
    r
  ), l(
    p.borderRadius.md,
    i.borderRadius.md,
    r
  ), l(
    p.borderRadius.lg,
    i.borderRadius.lg,
    r
  ), l(
    p.borderRadius.xl,
    i.borderRadius.xl,
    r
  ), l(
    p.iconSize.xs,
    i.iconSize.xs,
    r
  ), l(
    p.iconSize.sm,
    i.iconSize.sm,
    r
  ), l(
    p.iconSize.md,
    i.iconSize.md,
    r
  ), y(p.spacing, i.spacings, r);
}
function y(i, a, r) {
  for (const u in p.spacing)
    l(
      i[u],
      a[u],
      r
    );
}
function T(i, a, r) {
  l(i.label, a.label, r), l(i.p, a.p, r), l(i.h6, a.h6, r), l(i.h5, a.h5, r), l(i.h4, a.h4, r), l(i.h3, a.h3, r), l(i.h2, a.h2, r), l(i.h1, a.h1, r), l(i["h1-xl"], a["h1-xl"], r), l(i["h1-2xl"], a["h1-2xl"], r), l(i["h1-3xl"], a["h1-3xl"], r), l(i.code, a.code, r);
}
function g(i, a) {
  d(i.label, a.label), d(i.p, a.p), d(i.h6, a.h6), d(i.h5, a.h5), d(i.h4, a.h4), d(i.h3, a.h3), d(i.h2, a.h2), d(i.h1, a.h1), d(i["h1-xl"], a["h1-xl"]), d(i["h1-2xl"], a["h1-2xl"]), d(i["h1-3xl"], a["h1-3xl"]), d(i.code, a.code);
}
function x(i, a) {
  d(i.xs, a.xs), d(i.sm, a.sm), d(i.md, a.md), d(i.lg, a.lg), d(i.xl, a.xl);
}
function R(i, a) {
  f(i.primary, a.primary), f(i.secondary, a.secondary), f(i.neutral, a.neutral), d(i.black, a.black), d(i.white, a.white), d(i.overlay, a.overlay), f(i.success, a.success), f(i.warning, a.warning), f(i.error, a.error), d(i.ai.purple, a.ai.purple), d(i.ai.teal, a.ai.teal);
}
function f(i, a) {
  for (const r of n)
    d(i[r], a[r]);
}
function d(i, a) {
  i.withDefault(a);
}
function l(i, a, r) {
  i.withDefault(
    `${Math.round(1e3 * a * 16 / r) / 1e3}rem`
  );
}
export {
  D as applyTheme
};
